<dashboard-header title="Settings and support" titleCssIcon="settings-icon"></dashboard-header>
<div class="light-theme-alt">
    <div class="container-fluid">
        <div class="row border-top border-bottom py-4 align-items-center">
            <div class="col-12 col-lg-9">
                <h3><i>EMAIL NEWSLETTER</i></h3>
                <div class="pt-2">
                    <i>
                        Get the latest updates about new Activity releases, new features and upcoming meetups.
                    </i>
                </div>
            </div>
            <div class="col-12 col-lg-3 pt-3 pt-lg-0">
                <button class="btn btn-secondary col" *ngIf="subscriptionStatus == 'subscribed'" (click)="changeSubscriptionStatus()">Unsubscribe</button>
                <button class="btn btn-secondary col" *ngIf="subscriptionStatus != 'subscribed'" (click)="changeSubscriptionStatus()">Subscribe</button>
            </div>
        </div>
        <div class="row border-bottom py-4 align-items-center">
            <div class="col-12 col-md-6 col-lg">
                <h3><i>ACTIVITY SUPPORT</i></h3>
                <div class="pt-2">
                    <i>
                        If you need help with Activity material, exercises or concepts, email us or reach
                        out on Slack.
                    </i>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-auto pt-3 pt-lg-0 d-flex flex-column flex-lg-row">
                <button class="btn btn-primary px-5 mr-lg-3">get support via slack</button>
                <a role="button" href="mailto:support@equityisdynamic.com" class="btn btn-secondary px-5 mt-2 mt-lg-0">get support via email</a>
            </div>
        </div>
        <div class="row border-bottom py-4 align-items-center">
            <div class="col-12 col-lg-9">
                <h3><i>TECHNICAL SUPPORT</i></h3>
                <div class="pt-2">
                    <i>
                        If you're having technical issues, email us and we will get back to you within 2
                        business days.
                    </i>
                </div>
            </div>
            <div class="col-12 col-lg-3 pt-3 pt-lg-0">
                <a role="button" href="mailto:support@equityisdynamic.com" target="_blank" class="btn btn-secondary col">email technical support</a>
            </div>
        </div>
        <div class="row border-bottom py-4 align-items-center">
            <div class="col-12 col-md-6 col-lg">
                <h3><i>LEGAL</i></h3>
                <div class="pt-2">
                    <i>

                    </i>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-auto pt-3 pt-lg-0 d-flex flex-column flex-lg-row">
                <a role="button" href="https://www.equityisdynamic.com/terms-of-service" target="_blank" class="btn btn-secondary px-5 mr-lg-3">terms of service</a>
                <a role="button" href="https://www.equityisdynamic.com/privacy-policy" target="_blank" class="btn btn-secondary px-5 mt-2 mt-lg-0">privacy policy</a>
            </div>
        </div>
    </div>
</div>
<div class="light-theme">
    <div class="container-fluid">
        <div class="row py-4 align-items-center">
            <div class="col-12 col-lg-9">
                <h3><i>ABOUT</i></h3>
                <div class="pt-2">
                    <i class="text-blue font-weight-bold">Equity Is Dynamic</i> is <i class="text-blue">Elemental
                    Excelerator’s</i> home for equity-focused initiatives and
                    resources to help redesign the systems at the root of climate change in order to establish truly
                    equitable climate action.
                    <br/>
                    <i class="text-blue font-weight-bold">Journey</i> is an interactive and introspective tool that
                    helps climate tech founders and CEOs build and maintain equitable practices in their companies to
                    cultivate a more diverse, more inclusive, and stronger climate tech sector for those most impacted
                    by climate change.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-3 py-3 pt-lg-0">
                <a role="button" href="https://equityisdy1dev.wpengine.com/" target="_blank" class="btn btn-secondary col">Learn more</a>
            </div>
        </div>
    </div>
</div>